<script lang="ts">
  import QualityLayout from "../../../layout/QualityLayout.svelte";
</script>

<QualityLayout>
  <h1 class="title">Infestanti</h1>
  <p>
    <a class="button is-info" href="https://accesso.byronweb.net" target="_blank">Accedi a BYRONWEB</a>
  </p>
</QualityLayout>
